import emitter from "../utils/emitter"
import { onUnmounted } from "@vue/composition-api"
import tabtalk from "@shared/utils/tabtalk"

interface UseEventOptions {
  immediate?: boolean
}

export const useEmitterEvent = (
  type: string,
  listener: Function,
  options?: UseEventOptions,
) => {
  emitter.$on(type, listener)

  if (options && options.immediate) {
    listener()
  }

  const off = () => emitter.$off(type, listener)

  onUnmounted(off)

  return off
}

export const useTabtalk = (
  type: string,
  listener: Function,
  options?: UseEventOptions,
) => {
  tabtalk.$on(type, listener)

  if (options && options.immediate) {
    listener()
  }

  const off = () => tabtalk.$off(type, listener)

  onUnmounted(off)

  return off
}
interface UseAddEventListenerOptions
  extends AddEventListenerOptions,
    UseEventOptions {}

type ListenerType<K extends keyof ExtendedWindowEventMap, T> = T extends {
  immediate: Exclude<boolean, false>
}
  ? (evt?: ExtendedWindowEventMap[K]) => any
  : (evt: ExtendedWindowEventMap[K]) => any

export const useWindowEvent = <
  K extends keyof ExtendedWindowEventMap,
  F extends ListenerType<K, T>,
  T extends UseAddEventListenerOptions
>(
  type: K,
  listener: F,
  options?: T | boolean,
) => {
  window.addEventListener(type, listener, options)

  if (typeof options !== "boolean" && options?.immediate) {
    ;(listener as ListenerType<
      K,
      {
        immediate: true
      }
    >)()
  }

  const off = () => window.removeEventListener(type, listener, options)

  onUnmounted(off)

  return off
}
